export function style(element, styles) {
  for (const name in styles) {
    element.style[name] = styles[name];
  }
}

export function wrap(element) {
  const wrapper = document.createElement('div');
  element.parentNode.insertBefore(wrapper, element);
  wrapper.appendChild(element);
  return wrapper;
}

export const manipulations = {
  style: style,
  wrap: wrap,
};
